class Graphic {
	static fromArray(data, list) {
		let inst = new Graphic(list);
		inst._id = data._id;
		inst._name = data._name;
		inst._uploadedOn = data.uploaded_on;
		inst._ownerName = data.owner_name;
		inst._editable = data.edit;

		return inst;
	}

	constructor(list) {
		this._list = list;
		this._id = 0;
		this._name;
		this._uploadedOn;
		this._ownerName;
		this._editable;

		this._elem = null;
		this._chkBox = UI.chk(
			null,
			{
				'click': () => {this.select()}
			}
		);
		this._shareBtn = null;
		this._deleteBtn = null;
		this._clickable = true;
	}

	get id() {return this._id;}

	get checked() {return this._chkBox.checked;}
	set checked(v) {this._chkBox.checked = !!v;}

	get elem() {
		if (this._elem === null) {
			let buttons = [
				UI.secIconBtn(
					'tags', 22,
					{
						'click': this.showTags.bind(this)
					},
					{
						'data-tip': 'above',
						'aria-label': _('Tag graphic')
					}
				)
			];

			if (nav.entityType == Nav.USER) {
				let shareBtn = this._list.sharing.button(this._id);
				shareBtn.className = 'ed-sec-i-btn px-2 py-1 leading-none relative';
				buttons.push(shareBtn);
			}
			
			if (nav.unit && nav.unit.isAdmin) {
				let accessBtn = this._list.access.button(this._id);
				accessBtn.className = 'ed-sec-i-btn px-2 py-1 leading-none relative';
				buttons.push(accessBtn);
			}

			if (
				nav.entityType == Nav.USER || 
				(nav.unit && nav.unit.isAdmin)
			) {
				buttons.push(
					UI.secIconBtn(
						'delete', 22,
						{
							'click': this.delete.bind(this)
						},
						{
							'data-tip': 'above',
							'aria-label': _('Delete graphic')
						}
					)
				);
			}

			this._elem = UI.div('image-list-item', [
				this._img = UI.img(null, graphicSrc(this._id, AC.GRAPHIC_MED)),
				UI.div('absolute top-0 w-full flex items-center h-8 bg-neutral-900/50', [
					UI.styleChk(this._chkBox),
					UI.div('flex-1'),
					buttons
				], {
					'click': () => this._clickable = false
				}),
				UI.div('absolute bottom-0 w-full h-8 pt-1 text-center text-white bg-neutral-900/50', [
					p(null, this._name)
				])
			], {
				'click': () => {
					if (this._clickable) this.edit();
					this._clickable = true;
				}
			});
		}
		return this._elem;
	}

	edit() {
		if (this._list.selection.empty) {
			if (this._editable) GraphicEditor.fromId(this._id);
		}
		else {
			this.select();
		}
	}

	select() {
		this._list.selection.toggle(this);
	}

	showTags() {
		this._list.getTags(this.id, this._tagBtn);
	}

	delete() {
		Dialog.Confirm(
			_("Deleting this graphic, this CANNOT be undone!"),
			_("DELETE"),
			() => {
				API.delete('graphics/' + this._id)
				.then(_ => document.dispatchEvent(new Event('primaryDataInvalid')));
			}, null, WARNING_DELETE_GRAPHIC_SINGLE
		);
	}
}